import { filterBy } from "@progress/kendo-data-query";
import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import { Grid, GridCellProps, GridColumn } from "@progress/kendo-react-grid";
import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getOptionsSelector, updateMdcGroupingOptions } from "../Common/Slices/optionSlice";
import { useAppDispatch } from "../Core/store.hooks";

interface GridProps {}

const GroupingOptions = (props: GridProps) => {
    const [gridData, updateGridData] = useState([]);
    const groupingOptionsData = useSelector(getOptionsSelector).mdcGroupingOptions;
    const [filter, setFilter] = useState();

    const dispatch = useAppDispatch();

    useEffect(()=>{
        if(groupingOptionsData.length > 0){
            updateGridData(groupingOptionsData)
        }
    },[groupingOptionsData])

    const filterChange = (event: any) => {
        if (groupingOptionsData != null) {
            updateGridData(filterBy(groupingOptionsData, event.filter));
            setFilter(event.filter);
        }
    };

    const CustomCell = (props: GridCellProps) => {
        //console.log(props.dataItem);
        const handleGroupByChange = (e:DropDownListChangeEvent) =>{
            const modifiedCopy = groupingOptionsData.map((obj)=>{
                if(obj.unit === props.dataItem.unit){
                    return {"unit":obj.unit,"groupBy":e.target.value}
                }
                return obj;
            })
            dispatch(updateMdcGroupingOptions(modifiedCopy))
        }

        return(
            <td>
                <DropDownList 
                    data={["sum", "average"]}
                    value={props.dataItem.groupBy}
                    onChange={handleGroupByChange}
                />
            </td> 
        )
    }

    return (
        <Fragment>
            <Grid data={gridData}
                filterable={true}
                filter={filter}
                onFilterChange={filterChange}
                
            >
                <GridColumn field="unit" title="Unit"/>
                <GridColumn cell={CustomCell} filterable={false} title="Grouping Option"/>
            </Grid>
        </Fragment>
    );
};

export default GroupingOptions;
